<template>
  <div>
    <navbarBox />
    <addusercomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import addusercomponents from "@/components/addusercomponents.vue";
export default {
  components: { addusercomponents, navbarBox },
};
</script>
